module.exports = __webpack_public_path__ + "img/more1.b31f4d08.png";